import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Button, useUnselectAll } from 'react-admin';
import { AVATARS } from '@/utils/CONST';

interface Props {
    multiSelectionState: boolean;
    setMultiSelectionState: any;
}

const MultiSelectionButton = ({ setMultiSelectionState, multiSelectionState }: Props) => {
    const unselectAll = useUnselectAll(AVATARS);

    const handleClick = () => {
        unselectAll();
        setMultiSelectionState(!multiSelectionState);
    };

    return (
        <Button onClick={handleClick} label={'buttons.multi_selection'}>
            {multiSelectionState ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        </Button>
    );
};

export default MultiSelectionButton;
